import React, { useEffect, useState } from 'react';
import './invoice-preview-screen.scss';
import {
  getCustomerInvite,
  useAppSelector,
  useLazyGetDocumentsQuery,
  useLazyGetWorkspaceDocumentQuery,
} from '@zonofi/zono-money-store';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { SVGS } from '@zonofi/zono-money-design-system';
import { WEBROUTES } from '@zonofi/zono-money-helpers';

export const InvoicePreviewScreen: React.FC = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const subFolder = searchParams?.get('subFolder');
  const docNumber = searchParams?.get('docNumber');
  const showBack = searchParams?.get('showBack');
  const token = searchParams?.get('token');
  const sellerWorkspaceId = searchParams?.get('sellerWorkspaceId');
  const inviteId = searchParams?.get('inviteId');
  const { invoiceId } = params;

  const inviteDetails = useAppSelector(getCustomerInvite);
  const { seller } = inviteDetails;

  const [pdfURL, setPdfURL] = useState<string>();

  const [getPDFUrlAPI, getPDFUrlAPIResponse] = useLazyGetDocumentsQuery();
  const [getInvoicePDFUrlAPI, getInvoicePDFUrlAPIResponse] =
    useLazyGetWorkspaceDocumentQuery();

  useEffect(() => {
    // if (invoiceId) {
    // getPDFUrlAPI({
    //   workspaceId: seller?.workspaceId,
    //   documentType: 'invoice',
    //   entityId: invoiceId,
    //   subType: subFolder,
    // });
    getInvoicePDFUrlAPI({
      sellerWorkspaceId: seller?.workspaceId,
      documentType: 'invoice',
      entityId: invoiceId,
    });
    // }
  }, []);

  // useEffect(() => {
  //   if (getPDFUrlAPIResponse?.isSuccess) {
  //     let res = getPDFUrlAPIResponse?.data;
  //     if (res?.length !== 0) {
  //       let src = res?.filter((i) => i?.subType === 'official')?.[0]?.url;
  //       if (src) {
  //         setPdfURL(src);
  //       }
  //     }
  //   }
  // }, [getPDFUrlAPIResponse]);

  useEffect(() => {
    if (getInvoicePDFUrlAPIResponse?.isSuccess) {
      let res = getInvoicePDFUrlAPIResponse?.data;
      console.log('res: ', res);
      if (res?.[0]?.url) {
        setPdfURL(res?.[0]?.url);
      }
    }
  }, [getInvoicePDFUrlAPIResponse]);

  return (
    <div className="invoice-screen">
      <div className="invoice-screen-header">
        {showBack && (
          <img
            src={SVGS.LeftArrowBlack}
            alt="back"
            width={10}
            onClick={() => {
              navigate(
                `${WEBROUTES.INVOICE_SCREEN}?token=${token}&sellerWorkspaceId=${sellerWorkspaceId}&inviteId=${inviteId}`
              );
            }}
          />
        )}
        <span className=" font-primary-semibold">
          Invoice Details - {docNumber}
        </span>
      </div>
      {pdfURL ? (
        <iframe src={pdfURL} title="PDF Viewer" />
      ) : (
        <div className="invoice-screen-body">
          <span className="font-semibold">Something went wrong!</span>
        </div>
      )}
    </div>
  );
};
